module.exports = __webpack_public_path__ + "img/glaucoma.e5f2be91.png";